<template>
  <WEB
    v-if="from == 'web' || from == 'milestone'"
    :config="config"
    @login="login()"
    @resetPassword="resetPassword()"
  />

  <!-- ************* DJI ************* -->

  <DJI_RC_PLUS
    v-if="from == 'DJI_RC_PLUS'"
    :config="config"
    @login="login()"
    @resetPassword="resetPassword()"
  />

  <DJI_RC_PRO_E
    v-if="from == 'DJI_RC_PRO_E'"
    :config="config"
    @login="login()"
    @resetPassword="resetPassword()"
  />

  <!-- ************* AUTEL ************* -->
  <!-- ************* PARROT ************* -->
</template>

<script>
import { ref } from "vue";
import { toast } from "vue3-toastify";
import API from "@/utils/API";


/** -------- WEB -------- */
import WEB from "@/app/login/pages/web.vue";

/** -------- DJI -------- */
import DJI_RC_PRO_E from "@/app/login/pages/dji/DJI_RC_PRO_E.vue";
import DJI_RC_PLUS from "@/app/login/pages/dji/DJI_RC_PLUS.vue";

/** -------- AUTEL -------- */
// TODO

/** -------- PARROT -------- */
// TODO

export default {
  name: "App",
  props: {
    from: {
      type: String,
      default: "",
    },
  },
  components: {
    WEB,

    DJI_RC_PLUS,
    DJI_RC_PRO_E,
  },
  setup() {
    return {
      config: ref({
        email: "",
        password: "",
        error: false,
        load: false,
        lost: false,
        LogoForm: `
          <div class="flex justify-center">
            <svg class="w-1/3 hidden md:block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 46.292">
              <path
                d="M.69,32.09,7.9,30.452a16.757,16.757,0,0,1-.1-7.677L.589,21.137A23.812,23.812,0,0,0,.69,32.09Zm41.483-9.415a16.753,16.753,0,0,1-.1,7.877l7.215,1.638a23.809,23.809,0,0,0,.1-11.152Z"
                transform="translate(0 -3.468)" class="fill-flyingeye" />
              <path
                d="M10.457,30.272l6.42-1.433a8.678,8.678,0,0,1-.1-3.993l-6.421-1.433a14.751,14.751,0,0,0,.1,6.859Zm24.757-5.526,6.42-1.433a14.748,14.748,0,0,1-.105,7.058l-6.421-1.433a8.675,8.675,0,0,0,.106-4.192Z"
                transform="translate(-1.006 -3.696)" class="fill-flyingeye-light" />
              <path
                d="M4.129,11.672l6.326,3.588a16.5,16.5,0,0,1,2.611-3.03A17.559,17.559,0,0,1,16,10.066l-3.93-5.777A24.954,24.954,0,0,0,7.8,7.424,23.463,23.463,0,0,0,4.129,11.672ZM40.5,32.3a16.562,16.562,0,0,1-2.428,2.761A17.6,17.6,0,0,1,34.663,37.5l3.93,5.777a25,25,0,0,0,4.743-3.4,23.52,23.52,0,0,0,3.489-3.98Z"
                transform="translate(-0.415 -0.645)" class="fill-flyingeye" />
              <path
                d="M12.626,17.024l5.645,2.863a8.217,8.217,0,0,1,1.445-1.513,9.414,9.414,0,0,1,1.462-.978L17.67,12.787a16.036,16.036,0,0,0-2.652,1.752A14.005,14.005,0,0,0,12.626,17.024ZM34.393,28.063l5.644,2.863a14.117,14.117,0,0,1-2.2,2.239,16.165,16.165,0,0,1-3.136,2L31.19,30.554a9.538,9.538,0,0,0,1.946-1.224A8.328,8.328,0,0,0,34.393,28.063Z"
                transform="translate(-1.27 -0.837)" class="fill-flyingeye-light" />
              <path
                d="M12.138,43.216l3.93-5.776a17.585,17.585,0,0,1-3.318-2.384,16.572,16.572,0,0,1-2.37-2.679L4.053,35.964a23.54,23.54,0,0,0,3.432,3.9A25,25,0,0,0,12.138,43.216ZM34.731,10a17.568,17.568,0,0,1,3.023,2.217,16.484,16.484,0,0,1,2.666,3.113l6.326-3.588a23.441,23.441,0,0,0-3.727-4.331,24.962,24.962,0,0,0-4.358-3.186Z"
                transform="translate(-0.408 -0.638)" class="fill-flyingeye" />
              <path
                d="M17.74,36.429l3.506-4.881A9.456,9.456,0,0,1,19.393,30.3a8.625,8.625,0,0,1-1.2-1.264L12.55,32.067A14.606,14.606,0,0,0,14.7,34.36,16.06,16.06,0,0,0,17.74,36.429ZM31.262,17.606l3.506-4.881a16.006,16.006,0,0,1,2.743,1.907,14.471,14.471,0,0,1,2.448,2.712l-5.645,3.033a8.491,8.491,0,0,0-1.5-1.683A9.406,9.406,0,0,0,31.262,17.606Z"
                transform="translate(-1.262 -1.493)" class="fill-flyingeye-light" />
              <path
                d="M20.9.876l1.637,6.68a18.065,18.065,0,0,1,7.677-.093L31.853.782A25.67,25.67,0,0,0,20.9.876Zm9.415,38.407a18.058,18.058,0,0,1-7.877-.1L20.8,45.867a25.665,25.665,0,0,0,11.152.1Z"
                transform="translate(-1.376 -0.237)" class="fill-flyingeye" />
              <path
                d="M23.176,10.641l1.433,5.676a9.785,9.785,0,0,1,3.993-.09l1.433-5.677a16.634,16.634,0,0,0-6.859.09ZM28.7,32.53l1.433,5.676a16.627,16.627,0,0,1-7.058-.093l1.433-5.677a9.779,9.779,0,0,0,4.192.094Z"
                transform="translate(-1.605 -1.243)" class="fill-flyingeye-light" />
            </svg>
            <svg class="w-full fill-white max-w-[300px] md:hidden" xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1509.89 382.24">
              <g>
                <path
                  d="m377.73,144.57l-55.13,13.93c4.28,21.54,4.01,43.84-.79,65.26l55.15,13.91c6.76-30.57,7.02-62.4.77-93.1Zm-373.05-.84c-6.49,31.24-6.22,63.68.79,94.79l55.15-13.92c-5.04-21.95-5.31-44.87-.79-66.96l-55.15-13.91Z" />
                <path class="fill-[#7cb1de]"
                  d="m308.02,220.28c4.31-19.12,4.58-39.05.79-58.3l-48.27,12.18c2.08,11.24,1.81,22.83-.79,33.94l48.26,12.18h0Zm-186.1-46.97c-2.32,11.78-2.05,23.98.79,35.63l-48.27,12.18c-4.55-19.66-4.82-40.2-.79-59.99l48.26,12.18h0Z" />
                <path
                  d="m325.07,56.73c-9.93-9.79-20.81-18.42-32.43-25.73l-29.9,47.43c7.98,5.07,15.45,11.03,22.29,17.77,7.53,7.39,14.2,15.75,19.86,24.88l48.11-29.46c-7.98-12.8-17.36-24.51-27.94-34.89ZM28.27,290.49c7.68,11.94,16.58,22.9,26.53,32.67,10.97,10.81,23.08,20.19,36.07,27.95l29.9-47.43c-9.35-5.52-18.05-12.23-25.92-19.98-6.91-6.79-13.11-14.4-18.46-22.67l-48.13,29.46Z" />
                <path class="fill-[#7cb1de]"
                  d="m275.03,110.85c-6.11-5.67-12.74-10.66-19.78-14.89l-26.16,39.18c3.87,2.39,7.52,5.17,10.91,8.31,4.08,3.78,7.7,8.1,10.77,12.86l42.1-24.34c-5.12-7.81-11.11-14.9-17.84-21.12Zm-135.13,125.74c4.42,4.1,9.3,7.6,14.51,10.4l-26.16,39.18c-8.39-4.65-16.24-10.36-23.39-17-6.12-5.66-11.64-12.05-16.45-19.03l42.1-24.34c2.76,3.95,5.9,7.56,9.38,10.79Z" />
                <path
                  d="m327.44,323.13c9.77-9.6,18.52-20.33,26.1-32.01l-48.13-29.44c-5.26,8.01-11.3,15.39-18.03,22-7.68,7.55-16.15,14.11-25.24,19.55l29.9,47.43c12.73-7.68,24.61-16.92,35.39-27.53ZM90.35,30.54c-11.9,7.4-23.01,16.17-33.16,26.15-10.75,10.56-20.26,22.51-28.33,35.56l48.11,29.47c5.75-9.4,12.57-17.99,20.29-25.57,7.04-6.93,14.75-13.04,22.99-18.2l-29.9-47.42Z" />
                <path class="fill-[#7cb1de]"
                  d="m277.4,269.11c5.93-5.49,11.3-11.66,16.01-18.4l-42.1-24.34c-2.65,3.71-5.65,7.12-8.94,10.18-4.22,3.92-8.86,7.28-13.82,10.02l26.15,39.1c8.13-4.57,15.75-10.12,22.7-16.57Zm-123.55-134.45c-4.12,2.47-8,5.38-11.58,8.7-4.27,3.95-8.03,8.49-11.18,13.51l-42.11-24.34c5.21-8.06,11.34-15.37,18.26-21.76,6.31-5.86,13.17-10.98,20.46-15.3l26.15,39.17v.03Z" />
                <path
                  d="m148.04,4.51l12.9,55.16c19.97-4.29,40.54-4.02,60.41.77l12.88-55.16c-28.36-6.76-57.73-7.02-86.19-.77Zm-.78,373.05c28.97,6.49,58.89,6.22,87.76-.79l-12.89-55.16c-20.37,5.05-41.51,5.32-61.98.79l-12.88,55.16Z" />
                <path class="fill-[#7cb1de]"
                  d="m164.14,79l11.28,45.99c10.42-1.99,21.09-1.74,31.42.72l11.28-45.99c-17.77-4.1-36.12-4.35-53.97-.73Zm10.49,178.11c10.93,2.2,22.16,1.94,32.99-.77l11.29,45.97c-18.27,4.34-37.17,4.6-55.54.76l11.28-45.99-.02.03Z" />
              </g>
              <g>
                <polygon
                  points="461.92 69.32 461.92 94.66 461.92 165.7 490.41 165.7 490.41 94.66 610.31 94.66 610.31 66.16 461.92 66.16 461.92 69.32" />
                <rect x="461.92" y="0" width="155.36" height="28.49" />
              </g>
              <polygon
                points="663.42 138.32 663.42 0 634.92 0 634.92 138.32 634.92 155.37 634.92 166.81 788 166.81 788 138.32 663.42 138.32" />
              <polygon
                points="982.79 0 942.5 0 870.73 71.77 799.15 .19 758.85 0 781.43 22.77 856.86 98.2 856.86 165.7 885.35 165.7 885.35 97.45 961.43 21.37 982.79 0" />
              <rect x="1002.19" y="0" width="28.49" height="165.69" />
              <polygon
                points="1256.93 0 1256.93 136.52 1175.96 53.64 1175.94 53.66 1123.53 0 1103.85 0 1084.16 0 1084.16 165.7 1112.66 165.7 1112.66 29.18 1193.63 112.06 1193.64 112.04 1246.06 165.7 1256.93 165.69 1256.93 165.7 1285.42 165.7 1285.42 0 1256.93 0" />
              <path
                d="m1402.86,77.55h106.96v39.37s4.69,48.78-58.69,48.78h-85.21s-52.31,1.11-52.31-48.24c0-68.02,0-45.44,0-74.16,0,0-2.97-43.29,51.51-43.29h105.17s39.54-1.47,39.54,35.74c0,13.48.08,20.28.08,20.28h-28.57v-15.16s.55-14.29-20.21-14.29h-101.39s-20.07-1.16-20.07,27.06v56.03s.66,28.82,28.97,28.82h82.25s29.39,2.49,29.39-24.37v-11.49h-77.43l.03-25.08Z" />
              <polygon class="fill-[#7cb1de]"
                points="583.22 216.55 583.22 282.7 489.01 282.7 489.01 216.55 460.51 216.55 460.51 282.7 460.51 311.2 460.51 382.24 489.01 382.24 489.01 311.2 583.22 311.2 583.22 382.24 611.72 382.24 611.72 311.2 611.72 282.7 611.72 216.55 583.22 216.55" />
              <path class="fill-[#7cb1de]"
                d="m705.14,382.18c-13.88-.07-23.99-7.63-30.73-20.22-2.92-5.46-4.07-11.42-4.06-17.7.04-42.59.02-85.16.02-127.75h29.26c0,41.23,0,82.46,0,123.69,0,3.84,1.04,7.1,4.13,9.42,1.88,1.41,4.01,1.82,6.25,1.82l73.49.02c4.32,0,7.79-1.51,9.54-5.87.64-1.57.83-3.45.84-5.19.19-41.28.23-82.54.29-123.82h29.27c-.04,42.66-.07,85.32-.13,127.97-.03,18.15-11.07,32.85-27.69,36.87-2.18.53-4.45.83-6.69.83l-83.79-.06Z" />
              <path class="fill-[#7cb1de]"
                d="m882.06,382.21v-165.66h134.46c17.77,0,33.04,14.16,35.31,32.92.47,3.88.34,7.85.34,11.78.35,14.31-.11,29.58-12.45,38.54,14.46,11.81,12.64,28.53,12.41,45.79-.23,19.93-16.43,36.93-36.17,36.65,0,0-133.91-.03-133.91-.03Zm28.93-134.84v38.69l106.41-.07c3.17-1.66,5.72-4.08,5.84-8.01.22-7.32.2-14.66.01-21.98-.1-3.93-2.77-7.1-6.38-8.11-1.35-.38-2.8-.5-4.2-.5l-101.68-.02Zm-.07,65.71v38.32l103.42-.02c4.82-.31,8.7-3.68,8.88-8.46.27-7.21.23-14.44,0-21.66-.12-4-4.33-8.26-7.54-8.26l-104.76.08Z" />
            </svg>
          </div>
        `,
      }),
    };
  },

  mounted() {},

  methods: {
    async login() {
      if (this.config.load) {
        return "";
      }

      this.config.load = true;

      this.config.error = await this.tryLogin(
        this.config.email,
        this.config.password
      );

      setTimeout(() => {
        this.config.load = false;
      }, 1500);
    },

    async tryLogin(email, password) {
      if (email == "" || password == "") {
        return "";
      }

      let log = await API.get("login", {
        Email: email,
        Pass: password,
      });

      if (log["Error"]) {
        return log["Error"];
      } else if (log["Access denied"]) {
        return log["Access denied"];
      } else if (log.con_id == undefined) {
        return "no_id";
      }

      await $root.user.login(log);

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    },

    async resetPassword() {
      if (this.config.email == "") {
        return "";
      }

      let r = await API.put("contactresetpass", {
        con_email: this.config.email,
      });

      if (r.Result == ENV.API_RESPONSE_VALID) {
        toast.success(
          this.$e(
            "Un email vous a été envoyé pour réinitialiser votre mot de passe."
          )
        );
      } else {
        toast.error(
          this.$e("Une erreur est survenue. Veuillez réessayer plus tard.")
        );
      }
    },
  },
};
</script>
